// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type FileImageFilledIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from file-image-filled.svg
 */
export default function FileImageFilledIcon(props: FileImageFilledIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="FileImageFilledIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M11 3.5V0H1.5a.5.5 0 0 0-.5.5v15a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5V4h-3.5l-.09-.008A.5.5 0 0 1 11 3.5M8.958 5.122a.41.41 0 0 1 .583 0l.055.069 3.333 5.143.039.073a.43.43 0 0 1-.305.585l-.08.008H9.23l.044-.1a.93.93 0 0 0-.12-.88l-1.79-2.456 1.54-2.373zM6.19 6.818a.41.41 0 0 0-.544 0l-.061.068-2.5 3.428-.04.067a.432.432 0 0 0 .297.612l.076.007h5l.076-.007c.27-.05.42-.36.297-.612l-.04-.067-2.5-3.428zM12.685.144A.5.5 0 0 0 12.333 0H12v2.75c0 .138.112.25.25.25H15v-.357a.5.5 0 0 0-.148-.356z"
        />
      </g>
    </svg>
  );
}
